import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import AuthActions from '../../Redux/AuthRedux'
class HomeScreen extends Component {
  signIn = async () => {
    await this.props.signIn({ user: 'jasan' })
    this.props.history.push('/LoggedInHome')
  }

  componentDidMount() {
    this.checkAuth()
  }
  checkAuth = () => {
    const { auth } = this.props
    const { user } = auth
    if (user) {
      this.props.history.push('/LoggedInHome')
    }
  }

  render() {
    return (
      <div style={styles.container}>
        Welcome, you are currently not logged in
        <button style={styles.button} onClick={this.signIn}>
          Sign In!
        </button>
      </div>
    )
  }
}

function mapStateToProps({ auth }, props) {
  return {
    auth,
  }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = dispatch => ({
  signIn: ({ user }) => dispatch(AuthActions.signIn({ user })),
})
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(HomeScreen),
)

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
  },
  button: {
    marginTop: 50,
    marginBottom: 50,
    padding: 12,
    backgroundColor: 'tomato',
    borderRadius: 4,
  },
}
